var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"to-app",rawName:"v-to-app"}],staticClass:"to-yoo-button"},[_c('i',{staticClass:"icon_discount",on:{"click":_vm.clickHnadler}}),_c('button',{on:{"click":_vm.clickHnadler}})])}
var staticRenderFns = []

export { render, staticRenderFns }